import { Breadcrumb, Fabric, MessageBar, MessageBarType, ProgressIndicator, SearchBox } from 'office-ui-fabric-react';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import {
  dismissAttachmentError,
  insertAttachment,
  loadAssetsForContainer,
  loadAttachmentsForAsset,
  loadContainerWithGenericFileSections,
  removeApiKey,
  setSelectedAssetId,
  showAttachments,
  showBrandfolders,
  showGettingStarted,
  updateSearchString
} from '../../actions';
import SectionList from '../../components/SectionList/SectionList';
import Title from '../../components/Title/Title';
import {
  getAllAssets,
  getAttachmentForSelectedAsset,
  getSelectedContainerWithGenericFileSections,
  getError,
  getLoadingAsset,
  getLoadingContainer,
  getSearchString,
  getSelectedContainer
} from '../../selectors';

import './Brandfolder.css';

class Brandfolder extends React.Component {
  static propTypes = {
    areAssetsLoading: PropTypes.bool.isRequired,
    assets: PropTypes.array,
    attachment: PropTypes.object,
    containerWithGenericFileSections: PropTypes.object,
    dismissAttachmentError: PropTypes.func.isRequired,
    error: PropTypes.string,
    insertAttachment: PropTypes.func.isRequired,
    isContainerLoading: PropTypes.bool.isRequired,
    loadAssetsForContainer: PropTypes.func.isRequired,
    loadAttachmentsForAsset: PropTypes.func.isRequired,
    loadContainerWithSections: PropTypes.func.isRequired,
    selectedContainer: PropTypes.object.isRequired,
    setSelectedAssetId: PropTypes.func.isRequired,
    showBrandfolders: PropTypes.func.isRequired,
    showAttachments: PropTypes.func.isRequired
    };

  componentDidMount() {
    this.props.loadContainerWithSections(this.props.selectedContainer);
    this.props.loadAssetsForContainer(this.props.selectedContainer, '');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.attachment !== this.props.attachment && this.props.attachment) {
      this.props.insertAttachment(this.props.attachment);
    }

    if (prevProps.searchString !== this.props.searchString) {
      this.props.loadAssetsForContainer(this.props.selectedContainer, this.props.searchString);
    }
  }

  render() {
    return (
      <Fabric>
        <Title onLogout={() => this.logout()}>Choose Asset</Title>
        <Breadcrumb
          items={[
            {
              text: 'Brandfolders',
              key: 'brandfolders',
              onClick: this.onBreadcrumbClick.bind(this)
            },
            { text: 'Assets', key: 'brandfolder', onClick: () => null, isCurrentItem: true }
          ]}
          ariaLabel={'Breadcrumb'}
        />
        <div style={{ marginTop: '10px' }}>
          <SearchBox
            placeholder="Search assets"
            onChange={e => this.props.updateSearchString(e)}
          />
        </div>
        {this.props.error && (
          <div className="message-bar">
            <MessageBar
              messageBarType={MessageBarType.error}
              isMultiline={false}
              onDismiss={() => this.props.dismissAttachmentError()}
              dismissButtonAriaLabel="Close"
            >
              {this.props.error}
            </MessageBar>
          </div>
        )}
        {this.props.areAssetsLoading &&
          this.props.isContainerLoading && (
            <div className="loading">
              <ProgressIndicator label="Loading Assets" />
            </div>
          )}
        {!this.props.areAssetsLoading &&
          !this.props.isContainerLoading && (
            <SectionList
              assets={this.props.assets}
              brandfolder={this.props.containerWithGenericFileSections}
              onClick={this.onClick.bind(this)}
              onClickAttachments={this.onClickAttachments.bind(this)}
            />
          )}
      </Fabric>
    );
  }

  logout() {
    this.props.removeApiKey();
    this.props.showGettingStarted();
  }

  onBreadcrumbClick(event, item) {
    this.props.showBrandfolders();
  }

  onClick(asset) {
    this.props.setSelectedAssetId(asset);
    this.props.loadAttachmentsForAsset(asset);
  }

  onClickAttachments(asset) {
    this.props.setSelectedAssetId(asset);
    this.props.loadAttachmentsForAsset(asset);
    this.props.showAttachments();
  }
}

const mapStateToProps = state => ({
  areAssetsLoading: getLoadingAsset(state),
  assets: getAllAssets(state),
  attachment: getAttachmentForSelectedAsset(state),
  error: getError(state),
  containerWithGenericFileSections: getSelectedContainerWithGenericFileSections(state),
  isContainerLoading: getLoadingContainer(state),
  searchString: getSearchString(state),
  selectedContainer: getSelectedContainer(state)
});

const mapDispatchToProps = dispatch => ({
  dismissAttachmentError: () => dispatch(dismissAttachmentError()),
  insertAttachment: attachment => dispatch(insertAttachment(attachment)),
  loadAssetsForContainer: (brandfolder, searchString) => dispatch(loadAssetsForContainer(brandfolder, searchString)),
  loadAttachmentsForAsset: asset => dispatch(loadAttachmentsForAsset(asset)),
  loadContainerWithSections: container => dispatch(loadContainerWithGenericFileSections(container)),
  removeApiKey: () => dispatch(removeApiKey()),
  setSelectedAssetId: asset => dispatch(setSelectedAssetId(asset)),
  showBrandfolders: () => dispatch(showBrandfolders()),
  showAttachments: () => dispatch(showAttachments()),
  showGettingStarted: () => dispatch(showGettingStarted()),
  updateSearchString: searchString => dispatch(updateSearchString(searchString))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Brandfolder);



// WEBPACK FOOTER //
// ./src/containers/Brandfolder/Brandfolder.js